import { createSlice } from "@reduxjs/toolkit";
import { getMaterialDetailsAPI } from "../../services/getMaterialDetails";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const getMaterialDetailsSlice = createSlice({
  name: "getMaterialDetails",
  initialState: data,
  reducers: {
    getMaterialDetailsInfo(state) {
      state.isLoading = true;
      state.error = "";
      state.message = "";
    },
    getMaterialDetailsInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = action?.payload?.message || "";
      state.error = "";
    },
    getMaterialDetailsInfoFailure(state, action) {
      state.isLoading = false;
      state.message = "";
      state.error = action.payload;
      state.data = null;
    },
    getMaterialDetailsInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const getMaterialDetailsHandler = (payload) => async (dispatch) => {
  try {
	  dispatch(getMaterialDetailsAction.getMaterialDetailsInfo());
	  console.log("payload", payload);
	  const response = await getMaterialDetailsAPI(payload); 
	console.log("response", response);
    dispatch(getMaterialDetailsAction.getMaterialDetailsInfoSuccess(response));
  } catch (e) {
    const errorMessage =
      typeof e === "string"
        ? e
        : e?.response?.data?.message || e?.message || "Something went wrong";
    dispatch(getMaterialDetailsAction.getMaterialDetailsInfoFailure(errorMessage));
  }
};

export default getMaterialDetailsSlice.reducer;
export const getMaterialDetailsAction = getMaterialDetailsSlice.actions;
